export default [
  // {
  //   title: "招聘管理",
  //   icon: "el-icon-s-home",
  //   children: [
  //     {
  //       path: "/Management/staff",
  //       title: "职位管理",
  //       name: "staffManagement",
  //       component: () => import("@/view/Management/Staff/index"),
  //     },
  //     {
  //       title: "简历管理",
  //       path: "/Management/Resume",
  //       name: "Resume",
  //       component: () => import("@/view/Management/Resume/index"),
  //     },
  //     {
  //       title: "储备人才",
  //       path: "/Management/talent",
  //       name: "Talent",
  //       component: () => import("@/view/Management/Talent/index"),
  //     },
  //   ],
  // },
  {
    icon: "3.0.0/pc/zwgl",
    path: "/Management/staff",
    title: "职位管理",
    name: "staffManagement",
    component: () =>
      import(
        /* webpackChunkName: "staffManagement" */ "@/view/Management/Staff/index"
      ),
  },
  {
    icon: "3.0.0/pc/jlgl",
    title: "简历管理",
    path: "/Management/Resume",
    name: "Resume",
    component: () =>
      import(/* webpackChunkName: "Resume" */ "@/view/Management/Resume/index"),
  },
  // {
  //   icon: "3.0.0/pc/fxrc",
  //   title: "发现人才",
  //   path: "/recommend",
  //   name: "Recommend",
  //   component: () => import("@/view/Recommend/index"),
  // },
  {
    icon: "3.0.0/pc/fxrc",
    title: "人才中心",
    path: "/TalentCenter",
    name: "TalentCenter",
    component: () =>
      import(
        /* webpackChunkName: "TalentCenter" */ "@/view/TalentCenter/index"
      ),
  },
  {
    icon: "3.0.0/pc/zpqy",
    title: "招聘权益",
    path: "/rights",
    name: "Rights",
    component: () =>
      import(/* webpackChunkName: "Rights" */ "@/view/Rights/index"),
  },
  {
    path: "/rights/list",
    title: "招聘权益列表",
    name: "RightsList",
    hide: true,
    component: () =>
      import(/* webpackChunkName: "RightsList" */ "@/view/Rights/list/index"),
  },

  {
    icon: "3.6.0/pc3-cooperate",
    title: "代招聘",
    path: "/cooperate",
    name: "Cooperate",
    isNew: true,
    component: () =>
      import(/* webpackChunkName: "Cooperate" */ "@/view/Cooperate/index"),
  },
  {
    icon: "3.0.0/pc/sz",
    path: "/info/index",
    title: "设置和管理",
    name: "info",
    component: () => import(/* webpackChunkName: "info" */ "@/view/Info/index"),
  },
];
